import i18next from 'i18next';
import * as React from 'react';
import { StandardLocalWidget, any, fromJSX } from "widgets-for-react";
import { FormControls } from "../../utils/forms";
import { ChangePasswordState, changePasswordStateUpdaters, changePasswordUpdaters } from "./changePasswordState";

export const changePasswordWidget: StandardLocalWidget<ChangePasswordState> = currentState =>
  any([
    currentState.validator.widget().map(changePasswordStateUpdaters.validation),
    fromJSX(setState =>
      <>
        <FormControls.FormItemInGroup
          controlId="formCurrentPassword"
          type="password"
          label={i18next.t("subscription:CurrentPassword")}
          value={currentState.input.current || ""}
          required={true}
          onChange={(newValue => setState(changePasswordStateUpdaters.input(changePasswordUpdaters.current(_ => newValue))))}
          validation={currentState.validatorResult.path("current")}
        />

        <FormControls.FormItemInGroup
          controlId="formNewPassword"
          type="password"
          label={i18next.t("subscription:NewPassword")}
          value={currentState.input.new || ""}
          required={true}
          onChange={(newValue => setState(changePasswordStateUpdaters.input(changePasswordUpdaters.new(_ => newValue))))}
          validation={currentState.validatorResult.path("new")}
          // showPasswordScore={}
        />
        <FormControls.FormItemInGroup
          controlId="formRepeatedPassword"
          type="password"
          label={i18next.t("subscription:NewPasswordRepeated")}
          value={currentState.input.repeated || ""}
          required={true}
          onChange={(newValue => setState(changePasswordStateUpdaters.input(changePasswordUpdaters.repeated(_ => newValue))))}
          validation={currentState.validatorResult.path("repeated")}
        />
      </>
    )
  ])
